import '../../assets/css/after event/List of Winner.css'
import ListOfWinnerHeaderComp from '../../components/after event/ListOfWinnerHeaderComp'
import ListOfWinnerAllComp from '../../components/after event/ListOfWinnerAllComp'


const ListOfWinnerAllPage = () =>{
    return(
        <>
        <br />
        <br />
        <ListOfWinnerHeaderComp></ListOfWinnerHeaderComp>
        <br />
        <br />
        <ListOfWinnerAllComp></ListOfWinnerAllComp>
        <br />
        <br />
        </>
    )
}

export default ListOfWinnerAllPage